import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  EXCEPTION_CATEGORY_ENUM,
  EXCEPTION_FILE_NAMES_ENUM,
  ExceptionTrackingService,
  HttpHeadersPayload,
  HttpRequestMethods,
  IDP_APPS,
  IExceptionMetadata
} from '@com-delta-idp/mnx-utils';
import { Observable, throwError } from 'rxjs';
import {
  SaveEmailAddressRequest,
  SaveEmailAddressResponse
} from '../../models/add-email-address.interface';
import { LoginModalEndpointsKeys } from '../../models/login-modal.enum';

@Injectable({
  providedIn: 'root'
})
export class AddEmailAddressApiService {
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private exceptionTrackingService: ExceptionTrackingService
  ) {}

  saveEmailAddress = (
    payload: SaveEmailAddressRequest,
    tokenHeaderFlag: boolean,
    tokenResponse: string
  ): Observable<SaveEmailAddressResponse> => {
    const headers: HttpHeadersPayload = {
      'Content-Type': 'application/json'
    };
    if (tokenHeaderFlag && tokenResponse) {
      headers.Authorization = 'Bearer ' + tokenResponse;
    }
    return new ApiBuilder<SaveEmailAddressRequest, SaveEmailAddressResponse>(
      this.http,
      this.appConfig
    )
      .app(IDP_APPS['LOGIN_MODAL'])
      .endpointKey(LoginModalEndpointsKeys['ADD_EMAIL_ADDRESS_URL'])
      .method(HttpRequestMethods['POST'])
      .payload(payload)
      .httpHeaders(headers)
      .errorHandler(this.handleError.bind(this))
      .create();
  };

  handleError(error: HttpErrorResponse): Observable<never> {
    const exceptionMetadata: IExceptionMetadata = {
      fileName: EXCEPTION_FILE_NAMES_ENUM.ADD_EMAIL_ADDRESS_API_SERVICE,
      methodName: 'handleError',
      exceptionCategory: EXCEPTION_CATEGORY_ENUM.API_FAILURE,
      exceptionMessage: error.error
    };
    this.exceptionTrackingService.track(
      `[${IDP_APPS['LOGIN_MODAL']}]: ${error.status} : ${error.url}`,
      exceptionMetadata
    );
    return throwError(error);
  }
}
